module.exports = __webpack_public_path__ + "img/boy.a63597a8.png";